// extracted by mini-css-extract-plugin
export var callCard = "_r6-0";
export var callMessageButton = "_r6-1";
export var helpIcon = "_r6-3";
export var helpIconContainer = "_r6-4";
export var verticalDivider = "_r6-2";